"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterConjunctionDescMap = exports.FilterConjunction = exports.FilterDuration = exports.FOperatorDescMap = exports.FOperator = void 0;
const i18n_1 = require("../exports/i18n");
var FOperator;
(function (FOperator) {
    FOperator["Is"] = "is";
    FOperator["IsNot"] = "isNot";
    FOperator["Contains"] = "contains";
    FOperator["DoesNotContain"] = "doesNotContain";
    FOperator["IsEmpty"] = "isEmpty";
    FOperator["IsNotEmpty"] = "isNotEmpty";
    FOperator["IsGreater"] = "isGreater";
    FOperator["IsGreaterEqual"] = "isGreaterEqual";
    FOperator["IsLess"] = "isLess";
    FOperator["IsLessEqual"] = "isLessEqual";
    FOperator["IsRepeat"] = "isRepeat";
    FOperator["IsMax"] = "IsMax";
    FOperator["IsMin"] = "IsMin";
    FOperator["In"] = "In";
})(FOperator = exports.FOperator || (exports.FOperator = {}));
exports.FOperatorDescMap = {
    [FOperator.Is]: (0, i18n_1.t)(i18n_1.Strings.equal),
    [FOperator.IsNot]: (0, i18n_1.t)(i18n_1.Strings.not_equal),
    [FOperator.Contains]: (0, i18n_1.t)(i18n_1.Strings.contains),
    [FOperator.DoesNotContain]: (0, i18n_1.t)(i18n_1.Strings.does_not_contains),
    [FOperator.IsEmpty]: (0, i18n_1.t)(i18n_1.Strings.is_empty),
    [FOperator.IsNotEmpty]: (0, i18n_1.t)(i18n_1.Strings.is_not_empty),
    [FOperator.IsRepeat]: (0, i18n_1.t)(i18n_1.Strings.is_repeat),
    [FOperator.IsMax]: (0, i18n_1.t)(i18n_1.Strings.is_max),
    [FOperator.IsMin]: (0, i18n_1.t)(i18n_1.Strings.is_min),
    [FOperator.In]: (0, i18n_1.t)(i18n_1.Strings.In)
};
var FilterDuration;
(function (FilterDuration) {
    FilterDuration["ExactDate"] = "ExactDate";
    FilterDuration["DateRange"] = "DateRange";
    FilterDuration["Today"] = "Today";
    FilterDuration["Tomorrow"] = "Tomorrow";
    FilterDuration["Yesterday"] = "Yesterday";
    FilterDuration["ThisWeek"] = "ThisWeek";
    FilterDuration["PreviousWeek"] = "PreviousWeek";
    FilterDuration["ThisMonth"] = "ThisMonth";
    FilterDuration["PreviousMonth"] = "PreviousMonth";
    FilterDuration["ThisYear"] = "ThisYear";
    FilterDuration["SomeDayBefore"] = "SomeDayBefore";
    FilterDuration["SomeDayAfter"] = "SomeDayAfter";
    FilterDuration["TheLastWeek"] = "TheLastWeek";
    FilterDuration["TheNextWeek"] = "TheNextWeek";
    FilterDuration["TheLastMonth"] = "TheLastMonth";
    FilterDuration["TheNextMonth"] = "TheNextMonth";
})(FilterDuration = exports.FilterDuration || (exports.FilterDuration = {}));
var FilterConjunction;
(function (FilterConjunction) {
    FilterConjunction["And"] = "and";
    FilterConjunction["Or"] = "or";
})(FilterConjunction = exports.FilterConjunction || (exports.FilterConjunction = {}));
exports.FilterConjunctionDescMap = {
    [FilterConjunction.And]: (0, i18n_1.t)(i18n_1.Strings.operator_and),
    [FilterConjunction.Or]: (0, i18n_1.t)(i18n_1.Strings.operator_or),
};
//# sourceMappingURL=view_types.js.map